import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmAiGovernanceNativeAiCapabilitiesRoute: InvariantJiraRoute = {
	name: 'products-jsm-rovo-ai-ai-controls',
	path: '/jira/settings/products/jira-service-management-rovo-ai/ai-controls',
	exact: true,
};
